var map = {
	"./HausLebenSchmetterling.webp": 710,
	"./Logo_Doceins.webp": 29,
	"./Logo_Medifalk.webp": 167,
	"./PHOTO-2024-01-09-13-09-15.webp": 357,
	"./PHOTO-2024-01-09-13-09-15_mobile.webp": 604,
	"./PHOTO-2024-01-09-13-09-15_old.webp": 783,
	"./PHOTO-2024-01-09-13-09-26.webp": 543,
	"./Schaubild_1.webp": 163,
	"./Schaubild_2.webp": 642,
	"./TeamPalliativHausLebenFalkenberg27.webp": 308,
	"./aerzteIcon.webp": 922,
	"./burgerMenu.webp": 44,
	"./chevron_clean_down.webp": 620,
	"./chevron_clean_up.webp": 585,
	"./chevron_icon_down_orange.webp": 335,
	"./chevron_icon_up_orange.webp": 96,
	"./chevron_left_black .webp": 797,
	"./chevron_right_black.webp": 820,
	"./clock_icon.webp": 176,
	"./contact_phone_icon.webp": 807,
	"./emergencyPlaceholder.webp": 956,
	"./emergencyPlaceholder_old.webp": 822,
	"./hr-connector.png": 464,
	"./hr-conntector.webp": 984,
	"./hr-conntector_2.png": 143,
	"./hr-conntector_old.webp": 994,
	"./kaufmannIcon.webp": 530,
	"./logoHausLeben.webp": 258,
	"./logoHausLeben_white.webp": 927,
	"./mail_icon.webp": 411,
	"./notruf_icon.webp": 508,
	"./pflegeIcon.webp": 458
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 382;